// extracted by mini-css-extract-plugin
module.exports = {"seeLiveProject10":"CRM2-module--seeLiveProject10--vouCL","sourceCodeProject10":"CRM2-module--sourceCodeProject10--3MDPz"};